import { OrganizationMemberAccessLogColumn } from "@common/types/views/organizationMemberAccessLogView";
import { OrganizationMemberClientAccessSort } from "@common/types/organizationMemberClientAccess";
import { ViewConfig } from "@lib/views";
import { MemberAccessLogRow } from "./memberAccessLogRow";
import { MemberCell } from "./cells/MemberCell";
import { ClientCell } from "./cells/ClientCell";
import { SourceCell } from "./cells/SourceCell";
import { CreatedAtCell } from "./cells/CreatedAtCell";

export const memberAccessLogViewConfig: ViewConfig<
    MemberAccessLogRow,
    OrganizationMemberAccessLogColumn,
    OrganizationMemberClientAccessSort
> = {
    columns: {
        [OrganizationMemberAccessLogColumn.MEMBER]: {
            accessorKey: "userId",
            name: "Member",
            header: "Member",
            cell: MemberCell,
            immutable: true,
            minSize: 220,
            maxSize: 320,
        },
        [OrganizationMemberAccessLogColumn.CLIENT]: {
            accessorKey: "clientWorkspaceId",
            name: "Client",
            header: "Client",
            cell: ClientCell,
            minSize: 220,
            maxSize: 320,
        },
        [OrganizationMemberAccessLogColumn.SOURCE]: {
            accessorKey: "source",
            name: "Source",
            header: "Source",
            cell: SourceCell,
            minSize: 140,
            maxSize: 200,
        },
        [OrganizationMemberAccessLogColumn.CREATED_AT]: {
            accessorKey: "createdAt",
            name: "Accessed",
            header: "Accessed",
            cell: CreatedAtCell,
            sort: {
                asc: OrganizationMemberClientAccessSort.CREATED_AT_ASC,
                desc: OrganizationMemberClientAccessSort.CREATED_AT_DESC,
            },
            minSize: 160,
            maxSize: 220,
        },
    },
};
